module.exports = __webpack_public_path__ + "img/export-icon-with-bg-blue.ca1d0342.svg";